import React, { Suspense, lazy } from 'react';

import './App.css';
import './styles/main.css';
import { SuspenseLoading } from 'components/suspense-loading';
import AppProvider from './hooks';
import GlobalStyle from './styles/index';

const Routes = lazy(() => import('./routes'));

const App = () => (
  <Suspense fallback={<SuspenseLoading />}>
    <AppProvider>
      <Routes />
    </AppProvider>
    <GlobalStyle />
  </Suspense>
);

export { App };
